export const setUser = (user) => {
  console.log('Dispatching SET_USER with:', user);
  return {
    type: 'SET_USER',
    payload: user,
  };
};

export const clearUser = () => ({
  type: 'CLEAR_USER',
});

export const setUserCardList = (cardList) => {
  console.log('Dispatching SET_CARD_LIST with:', cardList);
  return {
    type: 'SET_CARD_LIST',
    payload: cardList,
  };
};
